import { IEditableColumn } from "../../helpers/interfaces/payments-reports";

export const paymentColumns: IEditableColumn[] = [
    { key: 'vendor', title: 'VENDITORE', type: 'text', width: '120px' },
    { key: 'orderConfirmationNumber', title: 'CONFERMA ORDINE N°', type: 'text', width: '130px' },
    { key: 'grossAmount', title: 'IMPORTO LORDO', type: 'number', width: '110px' },
    { key: 'netAmount', title: 'IMPORTO NETTO', type: 'number', width: '110px' },
    { key: 'recipient', title: 'INTESTATARIO', type: 'text', width: '180px' },
    { key: 'date', title: 'DATA', type: 'date', width: '110px' },
    { key: 'part', title: 'RICAMBIO', type: 'text', width: '150px' },
    { key: 'monthProgressive', title: 'PROGR MESE', type: 'integer', width: '90px' },
    { key: 'paymentVerification', title: 'VERIFICA PAGAMENTO', type: 'text', width: '120px' },
    { key: 'brand', title: 'MARCA', type: 'text', width: '100px' },
    { key: 'genre', title: 'GENERE', type: 'text', width: '100px' },
    { key: 'source', title: 'PROVENIENZA', type: 'text', width: '130px' },
    { key: 'affiliate', title: 'AFFILIATO', type: 'text', width: '120px' },
    { key: 'demolition', title: 'DEMOLIZIONE', type: 'text', width: '100px' },
    { key: 'link', title: 'LINK', type: 'text', width: '150px' },
    { key: 'email', title: 'MAIL', type: 'email', width: '180px' },
    { key: 'phone', title: 'NUMERO TELEFONO', type: 'text', width: '130px' },
    { key: 'firstName', title: 'NOME', type: 'text', width: '120px' },
    { key: 'lastName', title: 'COGNOME', type: 'text', width: '120px' },
    { key: 'paymentDate', title: 'DATA PAGAMENTO', type: 'date', width: '130px' },
];

export const refundColumns: IEditableColumn[] = [
    { key: 'vendor', title: 'VENDITORE', type: 'text', width: '120px' },
    { key: 'creditNoteNumber', title: 'NOTA CREDITO N°', type: 'text', width: '130px' },
    { key: 'orderConfirmationNumber', title: 'CONFERMA ORDINE N°', type: 'text', width: '130px' },
    { key: 'amount', title: 'IMPORTO', type: 'number', width: '110px' },
    { key: 'recipient', title: 'INTESTATARIO', type: 'text', width: '180px' },
    { key: 'date', title: 'DATA', type: 'date', width: '110px' },
    { key: 'part', title: 'RICAMBIO', type: 'text', width: '150px' },
    { key: 'monthProgressive', title: 'PROGR MESE', type: 'integer', width: '90px' },
    { key: 'brand', title: 'MARCA', type: 'text', width: '100px' },
    { key: 'genre', title: 'GENERE', type: 'text', width: '100px' },
    { key: 'legalReview', title: 'RECENS O LETTERA LEGALE', type: 'text', width: '160px' },
];

export const paymentAdminColumns = ['grossAmount', 'netAmount', 'paymentVerification'];
export const refundAdminColumns = ['amount'];
